import React, { useState, useContext, useEffect } from "react";
import { Button, ButtonGroup, Grid, Paper, Tooltip } from "@material-ui/core";

import "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import Fade from "@material-ui/core/Fade";

import { withStyles, makeStyles } from "@material-ui/core/styles";

import PaymentContext from "../../../context/paypal/payments/PaymentContext";

const PaymentFilter = ({
  setPaymentItems,
  checked,
  setChecked,
  state,
  setChecked1,
  setChecked2,
  setChecked3,
  setChecked4,
}) => {
  const paymentContext = useContext(PaymentContext);
  const { loading, payments, getPayments, payments_unmatched, payment } =
    paymentContext;
  const [dateIndex, setDateIndex] = useState(null);
  const [dateError, setDateError] = useState();
  const [dateFromSelected, setDateFromSelected] = useState(
    new Date().setHours(0, 0, 0, 0)
  );
  const [dateToSelected, setDateToSelected] = useState(
    new Date().setHours(0, 0, 0, 0)
  );

  // Convert date to GMT format function
  const dateFormatGMT = (date) => {
    return new Intl.DateTimeFormat("en-GB", {
      year: "numeric",
      month: "long",
      day: "2-digit",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: false,
      timeZone: "Asia/Kuala_Lumpur",
    }).format(new Date(date));
  };

  //Convert date to UTC format
  const dateFormatUTC = (date) => {
    date.setHours(-8, 0, 0, 0);
    let dateTime_split = new Intl.DateTimeFormat("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      timeZone: "Asia/Kuala_Lumpur",
    })
      .format(new Date(date))
      .split(", ");
    let date_split = dateTime_split[0].split("/");
    let date_selected =
      date_split[2] +
      "-" +
      date_split[1] +
      "-" +
      date_split[0] +
      "T" +
      dateTime_split[1] +
      ".000Z";

    return date_selected;
  };

  //Convert String to Camel Case
  const camelCaseFormat = (str) => {
    let str_split = str.toLowerCase().split("_");
    for (let i = 0; i < str_split.length; i++) {
      str_split[i] =
        str_split[i].charAt(0).toUpperCase() + str_split[i].substring(1);
    }
    return str_split.join(" ");
  };

  useEffect(() => {
    // max date range 7 days
    const maxRange = 7 * 24 * 60 * 60 * 1000;
    const dateFrom = new Date(dateFromSelected);
    const dateTo = new Date(dateToSelected);
    if (dateFrom > dateTo) {
      setDateError("Date From is greater than Date To");
    } else if (dateTo - dateFrom >= maxRange) {
      setDateError("Maximum 7 days date range only");
    } else {
      setDateError("");
    }
  }, [dateFromSelected, dateToSelected]);

  // Set data to Table after filtering
  useEffect(() => {
    if (payments) {
      let payments_sorted = [];
      let payments_items = [];
      if (checked) {
        payments_sorted = []
          .concat(payments_unmatched)
          .sort((a, b) => (a.create_time > b.create_time ? -1 : 1));
      } else {
        payments_sorted = []
          .concat(payments)
          .sort((a, b) => (a.create_time > b.create_time ? -1 : 1));
      }
      setPaymentItems(() => []);
      setChecked1(true);
      setChecked2(true);
      setChecked3(true);
      setChecked4(true);
      for (let x in payments_sorted) {
        let each = payments_sorted[x];
        let create_time = dateFormatGMT(each.create_time);
        let status = "";
        let gross = 0;
        let fee = 0;
        let net = 0;
        let shopify = each.shopify;
        let payment_type = each.payment_type;

        if (each.billing_agreement_id) {
          if (camelCaseFormat(each.state) === "Pending") {
            status = camelCaseFormat(each.state);
            gross = each.amount.total;
            fee = 0;
            net = each.amount.total;
          } else {
            status = camelCaseFormat(each.state);
            gross = each.amount.total;
            fee = each.transaction_fee.value;
            net = (gross - fee).toFixed(2);
          }
        } else {
          if (camelCaseFormat(each.status) === "Pending") {
            status = camelCaseFormat(each.status);
            gross = each.amount.value;
            fee = 0;
            net = each.amount.value;
          } else {
            status = camelCaseFormat(each.status);
            gross = each.seller_receivable_breakdown.gross_amount.value;
            fee = each.seller_receivable_breakdown.paypal_fee.value;
            net = each.seller_receivable_breakdown.net_amount.value;
          }
        }

        payments_items.push({
          id: each.id,
          create_time: create_time,
          status: status,
          gross: gross,
          fee: fee,
          net: net,
          shopify: shopify,
          payment_type: payment_type,
        });
      }
      setPaymentItems(payments_items);
    }
    //eslint-disable-next-line
  }, [payments, payments_unmatched, state.search_value === ""]);

  useEffect(() => {
    // max date range 7 days
    const maxRange = 7 * 24 * 60 * 60 * 1000;
    const dateFrom = new Date(dateFromSelected);
    const dateTo = new Date(dateToSelected);
    if (dateFrom > dateTo) {
      setDateError("Date From is greater than Date To");
    } else if (dateTo - dateFrom >= maxRange) {
      setDateError("Maximum 7 days date range only");
    } else {
      setDateError("");
    }
  }, [dateFromSelected, dateToSelected]);

  // Set data to Table after filtering
  useEffect(() => {
    if (payment) {
      let payment_items = [];
      setPaymentItems(() => []);
      setChecked1(true);
      setChecked2(true);
      setChecked3(true);
      setChecked4(true);
      for (let x in payment) {
        let each = payment[x];

        let create_time = dateFormatGMT(each.create_time);
        let status = "";
        let gross = 0;
        let fee = 0;
        let net = 0;
        let shopify = each.shopify;
        let payment_type = each.payment_type;

        if (each.billing_agreement_id) {
          if (camelCaseFormat(each.state) === "Pending") {
            status = camelCaseFormat(each.state);
            gross = each.amount.total;
            fee = 0;
            net = each.amount.total;
          } else {
            status = camelCaseFormat(each.state);
            gross = each.amount.total;
            fee = each.transaction_fee.value;
            net = (gross - fee).toFixed(2);
          }
        } else {
          if (camelCaseFormat(each.status) === "Pending") {
            status = camelCaseFormat(each.status);
            gross = each.amount.value;
            fee = 0;
            net = each.amount.value;
          } else {
            status = camelCaseFormat(each.status);
            gross = each.seller_receivable_breakdown.gross_amount.value;
            fee = each.seller_receivable_breakdown.paypal_fee.value;
            net = each.seller_receivable_breakdown.net_amount.value;
          }
        }

        payment_items.push({
          id: each.id,
          create_time: create_time,
          status: status,
          gross: gross,
          fee: fee,
          net: net,
          shopify: shopify,
          payment_type: payment_type,
        });
      }
      setPaymentItems(payment_items);
    }
    //eslint-disable-next-line
  }, [payment]);

  // On load, get all data from database
  useEffect(() => {
    onToday();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    setTimeout(() => setDateIndex(""), 10000);
  }, [dateIndex]);

  const getData = (date_from, date_to) => {
    const date_Index = date_from + " " + date_to;
    if (dateIndex !== date_Index) {
      getPayments(date_from, date_to);
      setDateIndex(date_Index);
      setChecked(false);
    }
  };

  const onToday = () => {
    const date_from = dateFormatUTC(new Date());
    const date_to = dateFormatUTC(
      new Date(new Date().setDate(new Date().getDate() + 1))
    );
    getData(date_from, date_to);
  };
  const onYesterday = () => {
    const date_from = dateFormatUTC(new Date(new Date() - 24 * 60 * 60 * 1000));
    const date_to = dateFormatUTC(new Date());
    getData(date_from, date_to);
  };
  const onLastThreeDays = () => {
    const date_from = dateFormatUTC(
      new Date(new Date() - 2 * 24 * 60 * 60 * 1000)
    );
    const date_to = dateFormatUTC(
      new Date(new Date().setDate(new Date().getDate() + 1))
    );
    getData(date_from, date_to);
  };
  const onLastSevenDays = () => {
    const date_from = dateFormatUTC(
      new Date(new Date() - 6 * 24 * 60 * 60 * 1000)
    );
    const date_to = dateFormatUTC(
      new Date(new Date().setDate(new Date().getDate() + 1))
    );
    getData(date_from, date_to);
  };

  const onDateSearch = () => {
    const date_from = dateFormatUTC(new Date(dateFromSelected));
    const date_to = dateFormatUTC(
      new Date(
        new Date(dateToSelected).setDate(new Date(dateToSelected).getDate() + 1)
      )
    );
    getData(date_from, date_to);
  };

  const useStyles = makeStyles((theme) => ({
    paper: {
      padding: theme.spacing(1),
      textAlign: "left",
      color: theme.palette.text.secondary,
    },
    buttonOutline: {
      "&:focus": {
        outline: "none",
      },
    },
  }));

  const LightTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: "#ffeeee",
      color: "#000000",
      boxShadow: theme.shadows[1],
      fontSize: 12,
    },
  }))(Tooltip);

  const classes = useStyles();

  return (
    <Paper className={classes.paper}>
      <Grid container direction="row" spacing={1}>
        <Grid item xs={12}>
          <Grid container direction="row" alignItems="center">
            <Grid item xs={7}>
              <ButtonGroup
                disableElevation
                variant="contained"
                color="primary"
                style={{
                  width: "90%",
                }}
              >
                <Button
                  onClick={onToday}
                  disabled={loading}
                  style={{
                    width: "25%",
                  }}
                  className={classes.buttonOutline}
                >
                  Today{" "}
                </Button>{" "}
                <Button
                  onClick={onYesterday}
                  disabled={loading}
                  style={{
                    width: "25%",
                  }}
                  className={classes.buttonOutline}
                >
                  Yesterday{" "}
                </Button>{" "}
                <Button
                  onClick={onLastThreeDays}
                  disabled={loading}
                  style={{
                    width: "25%",
                  }}
                  className={classes.buttonOutline}
                >
                  Last 3 Days{" "}
                </Button>{" "}
                <Button
                  onClick={onLastSevenDays}
                  disabled={loading}
                  style={{
                    width: "25%",
                  }}
                  className={classes.buttonOutline}
                >
                  Last 7 Days{" "}
                </Button>{" "}
              </ButtonGroup>{" "}
            </Grid>{" "}
            <Grid item xs={2}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  disableToolbar
                  variant="inline"
                  format="yyyy-MM-dd"
                  margin="normal"
                  id="date_from"
                  label="From"
                  disabled={loading}
                  autoOk={true}
                  maxDate={new Date()}
                  value={dateFromSelected}
                  onChange={(date) => setDateFromSelected(date)}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />{" "}
              </MuiPickersUtilsProvider>{" "}
            </Grid>{" "}
            <Grid item xs={2}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  disableToolbar
                  variant="inline"
                  format="yyyy-MM-dd"
                  margin="normal"
                  id="date_to"
                  label="To"
                  disabled={loading}
                  autoOk={true}
                  maxDate={new Date()}
                  value={dateToSelected}
                  onChange={(date) => setDateToSelected(date)}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />{" "}
              </MuiPickersUtilsProvider>{" "}
            </Grid>
            <Grid item xs={1}>
              <LightTooltip
                TransitionComponent={Fade}
                TransitionProps={{
                  timeout: 1000,
                }}
                title={dateError}
                open={dateError ? true : false}
                placement="top-end"
              >
                <Button
                  variant="contained"
                  color="primary"
                  onClick={onDateSearch}
                  disabled={loading || (dateError ? true : false)}
                  className={classes.buttonOutline}
                >
                  Search{" "}
                </Button>{" "}
              </LightTooltip>{" "}
            </Grid>{" "}
          </Grid>{" "}
        </Grid>{" "}
      </Grid>{" "}
    </Paper>
  );
};

export default PaymentFilter;
